/**
 * Concatenate class names, filtering out falsy values.
 *
 * Drop-in replacement for clsx for our simple needs. If we ever need
 * dedup or merge logic (e.g. tailwind-merge), upgrade in one place.
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
